import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";
import format from "date-fns/format";
import FileSaver from "file-saver";

export default makeListingMixin(
	"organisationUser",
	api.organisationUsers
)({
	actions: {
		async organisationUserExport(context, { id, name }) {
			try {
				// 1. call the api call for exporting org users
				const csv = await api.exportOrganisationUsers(id);

				// 2. create the filename for downloading
				name = name.replace(/\s+/g, "-").toLowerCase();
				const date = format(new Date(), "ddMMyyyy_HHmmss");
				const filename = `${name}-users-${date}.csv`;

				const csvFile = new Blob([csv], {
					type: "text/csv;charset=utf-8"
				});

				FileSaver.saveAs(csvFile, filename);
			} catch (error) {
				// Just rethrowing error for the moment.
				// will set isFetching to be false here though
				console.log(error);
				throw error;
			}
			// console.log(context);
		}
	}
});
